// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"oX-z","inlineTitle":"pX-z","sponsoredAdsWrapper":"qX-z","marketplaceRecosWrapper":"rX-z"};